import { PortableTextMarkComponent } from '@portabletext/react'

const FaqAnswerLink: PortableTextMarkComponent<{ _type: 'link'; href?: string }> = ({ children, value }) => (
  <a className="text-blue-logo underline" href={value?.href}>
    {children}
  </a>
)

export default FaqAnswerLink
